import '../snippets/product-gallery.js';
import '../components/back-in-stock.js';

$(function() {
  $('.product-template').on('variantChange', function (e) {
    if (e.variant) {
      $('[data-variant-sku]').html(e.variant.sku);
    }
  });
});
